import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';

import { KeySelectItem } from '@core/models/select-item.model';

/**
 * This component match the basic interface for
 * AvailableRuleItem {key: 'access_version', description: 'Access to versions'}
 */
@Component({
  selector: 'core-helpers-forms-key-select',
  templateUrl: './key-select.component.html',
  styleUrls: ['./key-select.component.scss'],
})
export class KeySelectComponent implements OnInit, OnChanges {

    @Input() disabled: boolean;
    @Input() optionSelected: string | number;
    @Input() label: string = "";
    @Input() options: KeySelectItem[] = [];
    @Input() placeholder: string;
    @Output() actionSelectItem = new EventEmitter<KeySelectItem>();
    public defaultOrder: boolean = false; // by normal we order by description. Stages has disabled elements
    public selected = "";

    public typeSafe:string;
    constructor(){}
    ngOnInit() {
        // Check if at least one object has 'disabled' property set to true
        this.defaultOrder = this.options.some(option => option.disabled === true);

            this.selected = this.getValueSelected();

    }

    ngOnChanges(changes: SimpleChanges){
        if(changes.options) {
            this.selected = this.getValueSelected();
        }
    }
    // CAREFULL with the string keys
    onChange(value: any){
        let option = this.options.filter((o: KeySelectItem)=> {
            return o.key.toString() == value;
        });

        this.actionSelectItem.emit(option[0]);
    }

    protected getValueSelected() {
        let options;
        if (this.optionSelected != null || this.optionSelected != undefined) {
            let optSelected = this.options.map( opt => {
                if (opt.key.toString() === this.optionSelected.toString()) {
                    return { ...opt, selected : true}
                } else {
                    return {...opt, selected: false}
                }
            });
            options = optSelected.filter(o => { return o.selected});
        } else {
            options = this.options.filter( o => { return o.selected});
        }
        

        return options.length > 0? options[0].key.toString() : "";
    }

    // this track function should prevent loops on rules when display the options.
    protected trackByFn(index: number, option: any): any {
        return option.key; // some unique identifier
    }

}
